import React from 'react'
import styles from './AppLayout.module.scss'
export function AppLayout(props: {children: React.ReactNode}) {
  return (
    <div className={styles.container}>
        <main>
            {props.children}
        </main>
    </div>
  )
}
